import { 
  FETCH_HELP_AND_SUPPORT_CONTENT_START, 
  FETCH_HELP_AND_SUPPORT_CONTENT_SUCCESS, 
  FETCH_HELP_AND_SUPPORT_CONTENT_FAILURE,
  FETCH_SITE_STAT_FAILED,
  FETCH_SITE_STAT_SUCCESS,
  FETCH_SITE_STAT_START
} from "../../store/actions/ActionConstant";

const initialState = {
  stats: {
    loading: false,
    data: null,
    error: false,
    message: null,
  },
  help_and_support: {
    loading: true,
    data: null,
    error: false,
  }
};

const SiteStatisticReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SITE_STAT_START:
      return {
        ...state,
        stats: {
          loading: true,
          data: null,
          error: null,
          message: null,
        },
      };
    case FETCH_SITE_STAT_SUCCESS:
      return {
        ...state,
        stats: {
          loading: false,
          data: action.data.data,
          error: null,
          message: action.data.message,
        },
      };
    case FETCH_SITE_STAT_FAILED:
      return {
        ...state,
        stats: {
          loading: false,
          data: null,
          error: action.error,
          message: action.message,
        },
      };
    case FETCH_HELP_AND_SUPPORT_CONTENT_START:
      return {
        ...state,
        help_and_support: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case FETCH_HELP_AND_SUPPORT_CONTENT_SUCCESS:
      return {
        ...state,
        help_and_support: {
          loading: false,
          data: action.data.data,
          error: null,
        },
      };
    case FETCH_HELP_AND_SUPPORT_CONTENT_FAILURE:
      return {
        ...state,
        help_and_support: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default SiteStatisticReducer;
